import {Injectable} from '@angular/core';
import {CalendarEvent} from 'angular-calendar';
import {API_URLS} from '../../../../../../environments/env-routes';
import {APIHelper} from '../../../../../../shared/services/api-helper/api-helper.service';
import {EventCalendar} from '../models/event-calendar.model';
import * as moment from 'moment'
//declare let moment;

export interface IEvent {
  fromDate: number;
  toDate: number;
  whatEvent: number;
  descriptionEvent: string;
  salle: string;
}

@Injectable({
  providedIn: 'root'
})
export class EventService {
  constructor(private api: APIHelper) {}

  loadEvents(begin: Date, end: Date): Promise<CalendarEvent[]> {
    // On divise par 1000 pour envoyer du timestamp en secondes et non pas en millisecondes
    const route = `${API_URLS.events.getAll}?from=${Math.round(
      +begin
    )}&to=${Math.round(+end)}`;

    return this.api.requestApi({ action: route, addFormat: true }).then(res => {
      const tabEvents: CalendarEvent[] = [];

      res.forEach(evObj => {
        const ev: EventCalendar = new EventCalendar(evObj);
        tabEvents.push(this.toDisplay(ev));
      });

      return tabEvents;
    });
  }

  createEvent(obj: any): Promise<any> {
    return this.api
      .requestApi({
        action: API_URLS.events.create,
        method: 'POST',
        datas: obj
      })
      .then(res => {
        if (res.error) {
          throw res.error;
        }
        return new EventCalendar(res);
      });
  }

  editEvent(eventName: string, obj: any): Promise<EventCalendar> {
    return this.api
      .requestApi({
        action: API_URLS.events.edit.replace(':eventName', eventName),
        method: 'PUT',
        datas: obj
      })
      .then(res => {
        if (res.error) {
          throw res.error;
        }
        return new EventCalendar(res);
      });
  }

  public deleteEvent(event: EventCalendar) {
    return this.api
      .requestApi({
        action: API_URLS.events.delete.replace(':eventName', event.eventName),
        method: 'DELETE'
      })
      .then(res => {});
  }

  public toDisplay(ev: EventCalendar): CalendarEvent<EventCalendar> {
    let addTitle;

    // Si évenement moins que 1h30 on applique un affichage différent
    if (+ev.toDate - +ev.fromDate < 1.5 * 3600 * 1000) {
      addTitle = `<p class="room-name">${ev.salleName} (${ev.whatEventFullname})</p>`;
    } else {
      addTitle = `<p class="room-name">${ev.salleName}<br/><span class="who">(${ev.whatEventFullname})</span></p>`;
    }

    const title = `
            <div class="time-display">${moment(ev.fromDate).format(
              'HH:mm'
            )} - ${moment(ev.toDate).format('HH:mm')}</div>
            <div class="time-display">${ev.descriptionEvent}</div>
            ${addTitle}
            <div class="room-name">Réservée par ${ev.organiserFullname}</div>
        `;

    // if (ev.descriptionEvent) {
    //     title += `<p class="desc">${ev.descriptionEvent}</p>`;
    // }

    return {
      start: ev.fromDate,
      end: ev.toDate,
      title: title,
      color: {
        primary: ev.salleColor,
        secondary: ev.salleColor
      },
      resizable: {
        beforeStart: true,
        afterEnd: true
      },
      draggable: true,
      meta: ev
    };
  }
}
